import BasicInfoComponent from './BasicInformationContainer';

export default BasicInfoComponent;